import { forwardRef } from "react";
import { Box } from "@mui/material";
import { Bars2Icon } from "@heroicons/react/24/outline";
import { PanelsTabs } from "features/editor/components/panels/PanelsTabs";

import { panelStyle, panelPinStyle } from "./styles";

export const Panels = forwardRef<
  HTMLInputElement,
  {
    onPanelResizeStart: any;
  }
>(({ onPanelResizeStart }, ref) => (
  <Box ref={ref} sx={panelStyle}>
    <Box onMouseDown={onPanelResizeStart} sx={panelPinStyle}>
      <Bars2Icon width={10} height={10} />
    </Box>
    <PanelsTabs />
  </Box>
));
